import { FooterContainer, FooterWrapper } from './Footer.styles';
import { FunctionalComponent, h } from 'preact';

import { useEffect, useRef } from 'preact/hooks';
import { memo } from 'preact/compat';
import { useDeviceState } from '../../hooks';
import { useUiContext } from '../../contexts/UiContext';

interface Props {
  ariaLabel: string;
  showBorder?: boolean;
}

const Footer: FunctionalComponent<Props> = memo(({ ariaLabel, children, showBorder = false }) => {
  const { isLandscape } = useDeviceState();
  const { footerHeight, setFooterHeight } = useUiContext();
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (footerRef && footerRef.current && footerRef.current.offsetHeight !== footerHeight) {
      setFooterHeight(footerRef.current.offsetHeight);
    }
  }, [isLandscape, footerHeight, setFooterHeight]);

  return (
    <FooterWrapper aria-label={ariaLabel} showBorder={showBorder} ref={footerRef}>
      <FooterContainer data-testid="uc-footer">{children}</FooterContainer>
    </FooterWrapper>
  );
});

export default Footer;
